var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDescuento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5.1Descuento") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.8Reservaciones",
    transform: "translate(-518.000000, -458.000000)",
    stroke: "#FE8D27",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(464.000000, 444.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(25.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.1Descuento",
    transform: "translate(54.500000, 23.334524) rotate(-315.000000) translate(-54.500000, -23.334524) translate(44.000000, 0.834524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,45 L0,45 L0,18.5982389 C0,17.8963614 0.289349848,17.2255898 0.799269661,16.747037 L8.79433799,9.24572094 C9.75567519,8.34364881 11.2443248,8.34364881 12.205662,9.24572094 L20.2007303,16.747037 C20.7106502,17.2255898 21,17.8963614 21,18.5982389 L21,45 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.846497,
    y1: 27.3448292,
    x2: 7.15350299,
    y2: 37.2875624,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5762677,36.7755109 C16.5762677,37.9064908 15.6671084,38.8237171 14.5460754,38.8237171 C13.4250424,38.8237171 12.515883,37.9064908 12.515883,36.7755109 C12.515883,35.6445309 13.4250424,34.7273046 14.5460754,34.7273046 C15.6671084,34.7273046 16.5762677,35.6445309 16.5762677,36.7755109 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.484117,27.856801 C8.484117,28.987781 7.57495765,29.9050073 6.45392463,29.9050073 C5.33289162,29.9050073 4.42373226,28.987781 4.42373226,27.856801 C4.42373226,26.7258211 5.33289162,25.8085948 6.45392463,25.8085948 C7.57495765,25.8085948 8.484117,26.7258211 8.484117,27.856801 Z",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5301924,16.3476846 C12.5301924,17.4786645 11.621033,18.3958908 10.5,18.3958908 C9.37896698,18.3958908 8.46980763,17.4786645 8.46980763,16.3476846 C8.46980763,15.2167047 9.37896698,14.2994784 10.5,14.2994784 C11.621033,14.2994784 12.5301924,15.2167047 12.5301924,16.3476846 Z",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4572488,8.17368278 C5.4572488,3.65933417 7.7151263,0 10.5003162,0 C13.2847156,0 15.5425931,3.65933417 15.5425931,8.17368278 C15.5425931,11.5817767 14.2563302,14.5025443 12.4277341,15.7292348",
    id: "Stroke-11"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescuento);
export default __webpack_public_path__ + "static/media/Descuento.60efe58ffc03d4efcc03922003974d50.svg";
export { ForwardRef as ReactComponent };